<template>
  <div class="container-fluid">
    <template v-if="can('my_account')">
    <div class="row">
      <div class="col-12">
        <h5 class="common_subtitle pb_20  font_16p pt_20">Basic Information </h5>

        <div class="row mb-3">
          <label for="inputEmail3" class="col-2 col-form-label">Account type</label>
          <div class="col-10">
            <input type="text" :value="profile.user_type" class="form-control" id="inputEmail3" readonly disabled>
          </div>
        </div>
        <InputField
            label="First name"
            type="first_name"
            v-model="profile.first_name"
            placeholder="First name"
            :required="true"
            :validation-error="errorFor('first_name')"
        />
        <InputField
            label="Last name"
            type="last_name"
            v-model="profile.last_name"
            placeholder="Last name"
            :required="true"
            :validation-error="errorFor('last_name')"
        />
        <InputField
            label="Email / Id"
            type="email"
            v-model="profile.email"
            placeholder="Email"
            :required="true"
            :validation-error="errorFor('email')"
        />
        <InputField
            label="Company"
            type="text"
            v-model="profile.company_name"
            placeholder="Company name"
            :required="true"
            :validation-error="errorFor('company_name')"
        />
        <InputField
            label="Password"
            type="password"
            v-model="profile.password"
            placeholder="Please enter mixed character (aA1@$!%*?#&) 8 digits"
            :required="true"
            :validation-error="errorFor('password')"
        />
        <h5 class="common_subtitle pb_20  font_16p pt_20">Contact Information </h5>
        <InputField
            label="Mobile Phone"
            type="text"
            v-model="profile.phone"
            placeholder="Mobile Phone"
            :required="true"
            :validation-error="errorFor('phone')"
        />
        <InputField
            label="Additional Email Address"
            type="email"
            v-model="profile.additional_email"
            placeholder="Additional Email Address"
            :required="true"
            :validation-error="errorFor('additional_email')"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="d_flex_end custom_border_top mt_20 pt_20">
          <button type="button" class="btn btn-primary btn-md  width_100p" @click.prevent="updateMyAccount">Update
          </button>
        </div>
      </div>
    </div>
    </template>
    <div v-else class="p-3">
      <p>You do not have permission to view this content.</p>
    </div>
  </div>
</template>

<script>
import InputField from "@/components/FormControl/InputFieldComponent.vue";
import {useAbility} from "@casl/vue";

export default {
  name: "MyAccount",
  components: {InputField},
  data() {
    return {
      profile: {
        first_name: '',
        last_name: '',
        email: '',
        password: '',
      },
    }
  },
  mounted() {
    this.getMyAccount()
  },
  methods: {
    getMyAccount() {
      this.axios.get('/my-account').then(({data}) => {
        this.profile = data.data
      })
    },
    updateMyAccount() {
      this.allErrors = null;
      this.axios.post('/update-account', {
        email: this.profile.email,
        first_name: this.profile.first_name,
        last_name: this.profile.last_name,
        company_name: this.profile.company_name,
        password: this.profile.password,
        phone: this.profile.phone,
        additional_email: this.profile.additional_email,
      })
          .then(({data}) => {
            if (data.success) {
              this.showSuccessMsg(data.message);
              this.profile = data.data
            }
          })
          .catch(({ response }) => {
            this.allErrors = response.data.errors
            this.showFailMsg(response.data.message);
          })
          .finally(() => this.loading = false);
    },
  },
  setup() {
    const { can } = useAbility();

    return {
      can
    };
  },
}
</script>

<style scoped>

</style>